import React from "react";
import * as SentryReact from "@sentry/react";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import { labelHelper } from "../../../helpers/labelHelper";
import BugSvg from "../../assets/bug.svg";

export const ModuleErrorFallback = ({
  error,
  resetError,
  eventId,
  clientName,
  lang,
}) => {
  const dialogOptions = {
    lang: "sv-SE",
    user: {
      name: clientName,
    },
  };
  return (
    <div className="error-boundry container">
      <div className="error-boundry card centered-text">
        <img
          style={{ maxWidth: 150, margin: "auto", marginBottom: 15 }}
          src={BugSvg}
        />
        <h2>
          <SystemLabel name="SomethingWentWrong" />
        </h2>
        <button onClick={() => SentryReact.showReportDialog(dialogOptions)}>
          <SystemLabel name="Report" />
        </button>
        <button
          style={{ background: "#eee", color: "#222" }}
          onClick={() => resetError()}
        >
          <SystemLabel name="RefreshModule" />
        </button>
        {/*       <button
          style={{ background: "#eee", color: "#222" }}
          onClick={() =>
            chrome.windows.create({
              url: window.location.href,
              incognito: true,
            })()
          }
        >
          <SystemLabel name="RefreshModule" />
        </button> */}
      </div>
    </div>
  );
};
